module.exports = __webpack_public_path__ + "img/img_83821_0_4.04efc8cf.png";